import { STRAPI_BASE_URL } from '@/config/api'
import type { MenuCategory, MenuItem } from '@/lib/types/pos'

export function resolvePOSImageUrl(imageUrl?: string | null): string | null {
  const value = imageUrl?.trim()
  if (!value) return null
  if (/^(https?:|data:|blob:)/i.test(value)) return value
  if (value.startsWith('/')) return `${STRAPI_BASE_URL.replace(/\/$/, '')}${value}`
  return value
}

function normalizeLabel(value?: string | null): string {
  return (value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

function fallbackMenuImage(categoryName?: string | null, kind: 'category' | 'item' = 'item'): string | null {
  const name = normalizeLabel(categoryName)
  const prefix = kind === 'category' ? 'category' : 'item'

  if (name.includes('pizz')) return kind === 'category' ? '/demo-menu/demores-category-pizze.svg' : '/demo-menu/demores-item-pizza.svg'
  if (name.includes('bibit') || name.includes('drink') || name.includes('bever')) {
    return kind === 'category' ? '/demo-menu/demores-category-bibite.svg' : '/demo-menu/demores-item-drink.svg'
  }
  if (name.includes('kebab') || name.includes('saltimbocca')) return `/demo-menu/demores-${prefix}-kebab.svg`
  if (name.includes('rostic') || name.includes('contorn') || name.includes('side')) return `/demo-menu/demores-${prefix}-rosticceria.svg`

  if (kind === 'category') {
    if (name.includes('starter') || name.includes('appet')) return '/demo-menu/category-starters.svg'
    if (name.includes('dessert') || name.includes('dolc')) return '/demo-menu/category-desserts.svg'
    if (name.includes('drink') || name.includes('bar')) return '/demo-menu/category-drinks.svg'
    return '/demo-menu/category-mains.svg'
  }

  if (name.includes('starter') || name.includes('appet')) return '/demo-menu/item-starter.svg'
  if (name.includes('dessert') || name.includes('dolc')) return '/demo-menu/item-dessert.svg'
  if (name.includes('drink') || name.includes('bar')) return '/demo-menu/item-drink.svg'
  return '/demo-menu/item-main.svg'
}

export function resolveMenuCategoryImageUrl(category?: MenuCategory | null): string | null {
  return resolvePOSImageUrl(category?.imageUrl) ?? resolvePOSImageUrl(fallbackMenuImage(category?.name, 'category'))
}

export function resolveMenuItemImageUrl(item?: MenuItem | null): string | null {
  return resolvePOSImageUrl(item?.imageUrl) ?? resolvePOSImageUrl(fallbackMenuImage(item?.category?.name, 'item'))
}
